$( document ).on('turbolinks:load', function() {
    $("tr[data-link]").click(function () {
        Turbolinks.visit($(this).data("link"))
    });
});
